module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/chicken-star4.b4a43087.png";